import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=1383e764&lang=pug&"
import script from "./Topics.vue?vue&type=script&lang=ts&"
export * from "./Topics.vue?vue&type=script&lang=ts&"
import style0 from "./Topics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports